import { FC, ReactNode, useEffect, useRef, useState } from 'react';

import classNames from 'classnames';

type Props = {
    dataTest?: string;
    type?: string;
    trigger?: any;
    className?: string;
    children: ReactNode;
    ariaLabel?: string;
};

const CssTransition: FC<Props> = ({ dataTest, type = 'fade', trigger = null, className, children, ariaLabel }) => {
    const [isMounted, setMounted] = useState(false);
    const [prevTrigger, setPrevTrigger] = useState(null);
    const isSafe = useRef(true);

    useEffect(() => {
        setMounted(true);
        isSafe.current = true;

        return () => {
            isSafe.current = false;
        };
    }, []);

    useEffect(() => {
        setTimeout(() => {
            if (isSafe.current) {
                setPrevTrigger(trigger);
            }
        }, 0);
    }, [trigger]);

    const classList = classNames(
        `${type}-enter`,
        isMounted && trigger === prevTrigger && `${type}-enter-active`,
        className,
    );

    return (
        <div data-test={dataTest} className={classList} aria-label={ariaLabel}>
            {children}
        </div>
    );
};

export default CssTransition;
